import React from 'react';
import style from './anonymousUserLayout.module.scss';
import backgroundStyle from 'acscp/styles/containerBackgrounds.module.scss';
import { NotificationBar } from 'acscp/components/common/notificationBar';
import { ErrorBoundary } from 'acscp/components/common/errorBoundary';
import { ScrollToTopOnMount } from 'acscp/components/common/scrollToTopOnMount';
import { LanguageMenu } from '../intl/languageMenu';
import classNames from 'classnames';

const AnonymousUserLayout: React.FC<{}> = ({ children }) => (
    <ErrorBoundary>
        <div className={style.Body}>
            <ScrollToTopOnMount />

            <LanguageMenu />
            <div className={classNames(style.Content, backgroundStyle.PlaneBackground)}>
                <NotificationBar />
                {children}
            </div>
        </div>
    </ErrorBoundary>
);

function withAnonymousUserLayout<P extends {}>(Wrapped: React.ComponentType<P>): React.ComponentType<P> {
    const HOC = (props: P) => (
        <AnonymousUserLayout>
            <Wrapped {...props} />
        </AnonymousUserLayout>
    );
    return HOC;
}

export { AnonymousUserLayout, withAnonymousUserLayout };
